import React from "react";
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";

const TableBody = ({
  id,
  className,
  onCellClick,
  style,
  children,
  secondaryDataList,
}) => {
  const tableBodyClass = cn(
    "align-middle border-collapse w-full overflow-hidden",
    className
  );

  const filteredChildren = filterChildren(children);

  const childrenWithFuncs = React.Children.map(
    filteredChildren,
    (child, index) =>
      React.cloneElement(child, {
        onCellClick: onCellClick || undefined,
        parent: "table-body",
        rowIndex: index,
        secondaryDataList,
      })
  );

  return (
    <tbody id={id} className={tableBodyClass} style={style}>
      {childrenWithFuncs}
    </tbody>
  );
};

TableBody.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** prop function when user clicks */
  onCellClick: PropTypes.func,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Data (in columns) to hide passed from TableRow component
   * @ignore
   */
  secondaryDataList: PropTypes.array,
};

TableBody.defaultProps = {
  id: "",
  className: "",
  children: [],
  style: {},
  onCellClick: null,
  secondaryDataList: [],
};

export default TableBody;
